"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToEnum = void 0;
const stringToEnum = (str, enumType, enumName) => {
    const value = enumType[str];
    if (typeof value === "undefined")
        throw new Error(`Invalid value for enum ` + enumName);
    return value;
};
exports.stringToEnum = stringToEnum;
//# sourceMappingURL=ts-utils.js.map